<!--
 * @Description:是否是销售员button
 * @Author: cxh
 * @Date: 2022-8-12 17:55:14
 * @LastEditTime: 2022-10-17 13:39:19
 * @LastEditors: mdb
-->
<template>
  <a-button v-bind="$attrs" :disabled="disabledComputed" v-show="showComputed">
    <slot></slot>
  </a-button>
</template>
<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { shareInfo } from '@dc-platform/dc-interaction'
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  workCode: {
    type: String
  },
  controlType: {
    type: String,
    default: 'disabled' // disabled=>按钮disabled属性 none 直接隐藏
  }
})
const userInfo = ref<any>({})
onMounted(() => {
  userInfo.value = shareInfo.getUserInfo() || {}
})
const showComputed = computed(() => {
  if (props.controlType === 'none') {
    if (props.workCode && userInfo.value.work_code) {
      return props.workCode === userInfo.value.work_code
    }
  }
  return true
})
const disabledComputed = computed(() => {
  if (props.disabled) {
    return true
  }
  // 判断是否是客户负责人
  if (props.workCode && userInfo.value.work_code) {
    return props.workCode !== userInfo.value.work_code
  }
  return false
})
</script>
